module.exports = __webpack_public_path__ + "static/media/ESTATUTO.129fd984.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/ESTATUTO.pdf
// module id = 84
// module chunks = 0